/* eslint-disable no-undef */
/* eslint-disable eqeqeq */
import { isApp, exclusiveidFn, pointParams, clickburiedPoint, commonburiedPoint } from './config'
import router from '../../../router'
import qs from 'qs'
import wx from 'weixin-js-sdk'

var arg = isApp()
export default {
  argFunc(h5Func, miniFunc, appFunc) {
    if (arg == '') {
      if (typeof h5Func == 'function') h5Func()
    } else if (arg.indexOf('xcx') >= 0) {
      if (typeof miniFunc == 'function') miniFunc()
    } else {
      if (typeof appFunc == 'function') appFunc()
    }
  },
  // creater: gaoenhui --h5&mini&app --h5内部跳转加arg参数
  // h5内部跳转 参数type支持'push'、'replace' 默认'push'
  argLink(link, type) {
    router[type ? type : 'push']({
      path: `${link.path}?${arg}`,
      query: link.query
    })
  },
  // creater: gaoenhui --h5&mini&app --h5内部跳转加arg参数
  argStaticLink(link) {
    window.location = link + (link.indexOf('?') >= 0 ? arg : arg ? '?' + arg : '')
  },
  goIntegral() {
    if (arg == '') {
      router.push({
        path: '/integral'
      })
    } else if (arg.indexOf('xcx') < 0) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'goIntegral'
        })
      )
    } else {
      wx.miniProgram.navigateTo({
        url: '/pages/integral/integralCenter/main?exclusiveid=' + exclusiveidFn() + pointParams('&')
      })
    }
  },
  goIntegralDetail() {
    if (arg == '') {
      router.push({
        path: '/integraldetails'
      })
    } else if (arg.indexOf('xcx') < 0) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'nineteen',
          nineteentype: 'nineteenintegral'
        })
      )
    } else {
      wx.miniProgram.navigateTo({
        url: '/pages/integral/integral/main?exclusiveid=' + exclusiveidFn() + pointParams('&')
      })
    }
  },
  goIndex() {
    // creater: gaoenhui --h5&mini&app --跳转首页
    if (arg == '') {
      window.location = '/'
    } else if (arg.indexOf('xcx') >= 0) {
      wx.miniProgram.reLaunch({
        url: '/pages/index/main?exclusiveid=' + exclusiveidFn() + pointParams('&')
      })
    } else {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'goIndex'
        })
      )
    }
  },
  navTitle(title) {
    // creater: gaoenhui --app --顶部标题
    if (arg != '' && arg.indexOf('xcx') < 0) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'navTitle',
          title: title
        })
      )
    }
  },
  saveimg(img) {
    // creater: gaoenhui --app --图片保存
    if (arg != '' && arg.indexOf('xcx') < 0) {
      window.ReactNativeWebView.postMessage(
        JSON.stringify({
          type: 'saveimg',
          img: img
        })
      )
    }
  },
  /**
   * 将商品添加到确认订单的流程中。
   * @param {Object} shopConfirmResult - 包含订单相关信息的对象。
   * @param {String} paramsStr - h5&mini所需参数，类型string，用于页面跳转时传递参数。
   * @param {Object} apparams - app所需参数，类型object，用于像app传递参数
   */
  addToConfirmOrder(shopConfirmResult, paramsStr = '', apparams = {}) {
    if (arg == '') {
      // 当arg为空时，将paramsStr解析为对象，并通过router跳转到订单页面，传递解析后的参数。
      const params = qs.parse(paramsStr)
      router.push({
        path: '/order',
        query: params
      })
    } else if (arg.indexOf('xcx') >= 0) {
      // 当arg包含'xcx'时，准备小程序订单页面跳转所需参数，并调用wx.miniProgram.navigateTo进行跳转。
      shopConfirmResult.orderHadOnShow = 0
      shopConfirmResult.isInitData = 1
      shopConfirmResult.live_id = ''
      shopConfirmResult.type = 'addToConfirmOrder'
      wx.miniProgram.navigateTo({
        url:
          '/pages/order/main?' +
          paramsStr +
          'shopConfirmResult=' +
          JSON.stringify(shopConfirmResult) +
          '&scenepoint=' +
          encodeURIComponent(window.document.title) +
          '&exclusiveid=' +
          exclusiveidFn() +
          pointParams('&')
      })
    } else {
      // 当arg为'app'||'ckapp'时，准备订单确认页面所需数据，并通过commonburiedPoint埋点记录订单确认操作。

      var obj = {
        type: 'addToConfirmOrder',
        skuids: shopConfirmResult.skuidArr.join(),
        item_num: shopConfirmResult.itemNum.join(),
        from: shopConfirmResult.from,
        ...apparams
      }
      commonburiedPoint({
        data: {
          scenepoint: window.document.title,
          scenedesc: window.location.href,
          url: 'order-confirm'
        },
        rnType: 'addToConfirmOrder',
        callback: () => {
          // 埋点完成后，通过postMessage向React Native发送订单数据。
          window.ReactNativeWebView.postMessage(JSON.stringify(obj))
        }
      })
    }
  },
  goItemDetail(itembaseid, query) {
    clickburiedPoint({
      url: 'ckysdatacenter/itemclick/save',
      data: {
        itemid: itembaseid,
        scenepoint: 'OTHERACT',
        scenedesc: window.location.href
      },
      callback: () => {
        this.argFunc(
          function() {
            router.push({
              path: '/productdetail',
              query: {
                itemid: itembaseid,
                ...query
              }
            })
          },
          function() {
            const params = qs.stringify(query)
            console.log(params)
            wx.miniProgram.navigateTo({
              url:
                '/pages/product/main?itemid=' +
                itembaseid +
                '&' +
                params +
                '&exclusiveid=' +
                exclusiveidFn() +
                pointParams('&')
            })
          },
          function() {
            window.ReactNativeWebView.postMessage(
              JSON.stringify({
                type: 'goItemDetail',
                itembaseid: itembaseid,
                ...query
              })
            )
          }
        )
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/assets/common/js/app_interactive.js